import dayjs from "dayjs";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  TransferRead,
  TransferService,
  TransferQueryParams,
  TransferCategory,
} from "@/domains/transfer";
import { RootState } from "@/stores";
import { DateRange } from "@/domains/common";

interface TenantMemberWithdrawState {
  loading: boolean;
  dateRange: DateRange;
  queryParams: TransferQueryParams;
  transfers: TransferRead[];
}

const initialState: TenantMemberWithdrawState = {
  loading: false,
  dateRange: DateRange.day0,
  queryParams: {
    created_started_at: dayjs().startOf("day").toISOString(),
    created_stopped_at: dayjs().endOf("day").toISOString(),
  },
  transfers: [],
};

export const tenantMemberWithdrawSelects = {
  loading: (state: RootState) => state.tenantMemberWithdraw.loading,
  dateRange: (state: RootState) => state.tenantMemberWithdraw.dateRange,
  queryParams: (state: RootState) => state.tenantMemberWithdraw.queryParams,
  transfers: (state: RootState) => state.tenantMemberWithdraw.transfers,
};

export const tenantMemberWithdrawThunks = {
  list: createAsyncThunk(
    "tenantMemberWithdraw/list",
    async (params: TransferQueryParams = {}) => {
      const res = await TransferService.list({
        ...params,
        category: TransferCategory.MemberWithdraw,
      }).run();

      return res.data.msg;
    }
  ),
};

export const tenantMemberWithdrawSlice = createSlice({
  name: "tenantMemberWithdraw",
  initialState,
  reducers: {
    setQueryParams: (state, action: PayloadAction<TransferQueryParams>) => {
      state.queryParams = action.payload;
    },
    setDateRange: (state, action: PayloadAction<DateRange>) => {
      state.dateRange = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(tenantMemberWithdrawThunks.list.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      tenantMemberWithdrawThunks.list.fulfilled,
      (state, action) => {
        state.loading = false;
        state.transfers = action.payload.transfers;
      }
    );
    builder.addCase(tenantMemberWithdrawThunks.list.rejected, (state) => {
      state.loading = false;
      state.transfers = [];
    });
  },
});

export const tenantMemberWithdrawActions = tenantMemberWithdrawSlice.actions;
